// <auto-generated>
// This file is automatically generated from DSL.
// Source: dsl/entities/SetupPackage.yaml
// Generated: 2026-08-13T09:51:21.657Z
// </auto-generated>

import { EntityService } from '@/lib/EntityService';
import { CreateSetupPackage, UpdateSetupPackage, SetupPackage } from '@/types/core/SetupPackage';

/**
 * SetupPackage Service
 * CRUD operations for SetupPackage via the ABP API.
 */
export const setupPackageService = new EntityService<SetupPackage, CreateSetupPackage, UpdateSetupPackage>(
  '/api/core/setuppackage',
  'SetupPackage',
);
